import { render, staticRenderFns } from "./TermsConditionsInput.vue?vue&type=template&id=5284be68"
import script from "./TermsConditionsInput.vue?vue&type=script&lang=js"
export * from "./TermsConditionsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports